import { useEffect, useState } from "react";
import { required, SelectInput, useDataProvider, useRecordContext } from "react-admin";
import { useForm } from "react-final-form";

export const MCDNAppName = () => {
  const [type, setType] = useState([]);

  const dataProvider = useDataProvider();
  const form = useForm();
  const record = useRecordContext();

  useEffect(async () => {
    const t = await dataProvider.getListMCDNAppNames();

    //Extract all values
    const t2 = [];
    t.data.map((item) => {
      item.values.map((item2) => {
        t2.push(item2);
      });
    });

    setType(t2);

    if (t2.length > 0) {
      let value;
      if (!record.mcdn_appname) {
        value = t2[0]; //default value
      } else {
        value = record.mcdn_appname;
      }

      form.change("mcdn_appname", value);
      form.change("mcdn_appname_select", value);
    }
  }, []);

  const onChange = (e) => {
    form.change("mcdn_appname", e.target.value);
  };

  const choices = type.map((item) => ({
    id: item,
    name: item,
  }));

  return (
    <>
      <SelectInput //
        label="MCDN App Name"
        source="mcdn_appname_select"
        choices={choices}
        // trnaslateChoice={false}
        allowEmpty={false}
        fullWidth
        onChange={onChange}
        validate={required()}
      />
    </>
  );
};
